<div class="row mt-5">
  <div class="col-12">

    <div class="text-left">
      <h2>Invitations</h2>
    </div>

    <hr>

      <div class="row">
        <div class="col-12">

          <div class="card">
            <div class="card-header">
              <div class="row align-items-center">
                <div class="col">

                  <!-- Title -->
                  <h4 class="card-header-title">
                    Employés invités
                  </h4>

                </div>
                <div class="col-auto">
                  @if (this.isLoading) {
                    <span class="text-muted me-3"><i class="fas fa-sync fa-spin"></i> Actualisation en cours</span>
                  }
                  @if (this.showHasBeenRefreshed) {
                    <span class="text-muted me-3">Actualisé</span>
                  }

                  <a (click)="refresh(); $event.preventDefault()" class="btn btn-link" href="">
                    Actualiser
                  </a>

                  <!-- Button -->
                  <!--                                <a href="#" routerLink="create" class="btn btn-primary btn-sm" role="button"-->
                  <!--                                   aria-haspopup="true" aria-expanded="false">-->
                  <!--                                    Nouveau questionnaire-->
                <!--                                </a>-->

              </div>
            </div> <!-- / .row -->
          </div>
          <div class="table-responsive mb-0"
            data-list="{&quot;valueNames&quot;: [&quot;goal-project&quot;, &quot;goal-status&quot;, &quot;goal-progress&quot;, &quot;goal-date&quot;]}">
            <table class="table table-sm table-nowrap card-table">
              <thead>
                <tr>
                  <th>
                    <a class="text-muted list-sort">
                      Email
                    </a>
                  </th>
                  <th>
                    <a class="text-muted list-sort">
                      Rôle
                    </a>
                  </th>
                  <th>
                    <a class="text-muted list-sort">
                      État
                    </a>
                  </th>
                </tr>
              </thead>
              <tbody class="list">
                @for (invite of invites; track invite) {
                  <tr class="table-row">
                    <td>
                      {{ invite.email }}
                    </td>
                    <td>
                      {{ getRole(invite.role) }}
                    </td>
                    <td>
                      <span [class.bg-light]="invite.status === statusEnum.Archived"
                        [class.bg-success]="invite.status === statusEnum.Accepted"
                        [class.bg-warning]="invite.status === statusEnum.Pending"
                        class="badge rounded-pill"
                        style="margin-left: 25px; font-size: 70%;"
                      >{{ getStatusText(invite.status) }}</span>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div> <!-- / .row -->

  </div>
</div> <!-- / .row -->